// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pressEntity from './entities/press.json';
import pressMenu from '../pages/press/menu.json';
import pressFullForm from '../pages/press/forms/full.json';
import pressContextForm from '../pages/press/forms/context.json';
import pressMiniForm from '../pages/press/forms/mini.json';
import pressLookupForm from '../pages/press/forms/lookup.json';
import pressTableView from '../pages/press/views/table.json';
import pressStagesView from '../pages/press/views/stages.json';
import pressCardsView from '../pages/press/views/cards.json';
import pressBacklogView from '../pages/press/views/backlog.json';
import pressCalendarView from '../pages/press/views/calendar.json';
import pressDashboardView from '../pages/press/views/dashboard.json';

/** Тип запису «Випуск» зі сторінками пакета: меню, форми та подання з pages/press/. */
export const pressDefinition: IRecordTypeDefinition = {
  ...pressEntity,
  views: assembleViewSet({
      table: pressTableView,
      stages: pressStagesView,
      cards: pressCardsView,
      backlog: pressBacklogView,
      calendar: pressCalendarView,
      dashboard: pressDashboardView,
  }),
  form: pressFullForm,
  forms: { full: pressFullForm, context: pressContextForm, mini: pressMiniForm, lookup: pressLookupForm },
  menu: pressMenu,
} as IRecordTypeDefinition;
